/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './ad.component.css.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../app/ad/ad.component';
const styles_AdComponent:any[] = [i0.styles];
export const RenderType_AdComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,styles:styles_AdComponent,
    data:{}});
export function View_AdComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),6,'div',[['class',
      'demo-card-wide mdl-card mdl-shadow--2dp ad-card']],(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i1.ɵeld(2,0,(null as any),(null as any),3,'div',[['class',
      'mdl-card__supporting-text']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n        '])),(_l()(),i1.ɵeld(4,
      0,(null as any),(null as any),0,'ins',[['class','adsbygoogle'],['data-ad-client',
          'ca-pub-4726807445608817'],['data-ad-format','fluid'],['data-ad-layout',
          'in-article'],['data-ad-slot','1046247731'],['style','display:block; text-align:center;']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i1.ɵted(-1,(null as any),['\n    '])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (null as any),(null as any));
}
export function View_AdComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-ad',([] as any[]),
      (null as any),(null as any),(null as any),View_AdComponent_0,RenderType_AdComponent)),
      i1.ɵdid(1,4308992,(null as any),0,i2.AdComponent,([] as any[]),(null as any),
          (null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const AdComponentNgFactory:i1.ComponentFactory<i2.AdComponent> = i1.ɵccf('app-ad',
    i2.AdComponent,View_AdComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2FkL2FkLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzk0NjMyOTQ3MC9zcmMvZnJvbnRlbmQvc3JjL2FwcC9hZC9hZC5jb21wb25lbnQudHMiLCJuZzovLy9jb2RlYnVpbGQvb3V0cHV0L3NyYzk0NjMyOTQ3MC9zcmMvZnJvbnRlbmQvc3JjL2FwcC9hZC9hZC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2NvZGVidWlsZC9vdXRwdXQvc3JjOTQ2MzI5NDcwL3NyYy9mcm9udGVuZC9zcmMvYXBwL2FkL2FkLmNvbXBvbmVudC50cy5BZENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJkZW1vLWNhcmQtd2lkZSBtZGwtY2FyZCBtZGwtc2hhZG93LS0yZHAgYWQtY2FyZFwiPlxuICAgIDxkaXYgY2xhc3M9XCJtZGwtY2FyZF9fc3VwcG9ydGluZy10ZXh0XCI+XG4gICAgICAgIDxpbnMgY2xhc3M9XCJhZHNieWdvb2dsZVwiIHN0eWxlPVwiZGlzcGxheTpibG9jazsgdGV4dC1hbGlnbjpjZW50ZXI7XCIgZGF0YS1hZC1sYXlvdXQ9XCJpbi1hcnRpY2xlXCIgZGF0YS1hZC1mb3JtYXQ9XCJmbHVpZFwiIGRhdGEtYWQtY2xpZW50PVwiY2EtcHViLTQ3MjY4MDc0NDU2MDg4MTdcIiBkYXRhLWFkLXNsb3Q9XCIxMDQ2MjQ3NzMxXCI+PC9pbnM+XG4gICAgPC9kaXY+XG48L2Rpdj4iLCI8YXBwLWFkPjwvYXBwLWFkPiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7OztvQkNBQTtNQUFBO01BQUEsNENBQTZEO01BQUEsYUFDekQ7TUFBQTtNQUFBLGdCQUF1QyxrREFDbkM7TUFBQTtVQUFBO1VBQUE7TUFBQSx3RUFBK0w7YUFBQSwrQkFDN0w7Ozs7b0JDSFY7TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /codebuild/output/src946329470/src/frontend/src/$$_gendir/app/ad/ad.component.ngfactory.ts